export const DEFAULT_IMAGE_SIZE = 48;
